import { __decorate } from "tslib";
import { Component, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { Router } from '@angular/router';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Modal Component
 */
let VerifyThirdPartiesModalComponent = class VerifyThirdPartiesModalComponent {
    constructor(httpClient, router, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.successColor = '';
        this.backColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.atms = [];
        this.lastOpenIndex = -1;
        this.activeTab = 1;
        this.cities = [];
        this.showCities = false;
        this.showAtms = [];
        this.city = 0;
        this.latitude = 44.4419211;
        this.longitude = 20.4830112;
        this.zoom = 7.2;
        this.checkedCity = '';
        this.waterColor = '';
        this.mainColor = '';
        this.secondaryColor = '';
        this.textColor = '';
        this.linkColor = '';
        this.tabColor = '';
        this.styles = {};
        this.clusterStyle = {
            textSize: 32
        };
        this.title = 'ECD maps';
        this.lat = 44.4419211;
        this.lng = 20.4830112;
        document.documentElement.style.overflowY = 'hidden';
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
        });
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'menu_atm_holder2' &&
            targetElement.className !== 'fa fa-caret-down' &&
            targetElement.className !== 'menu_one') {
            this.closeCities();
        }
    }
    closeCities() {
        this.showCities = false;
    }
    ngOnInit() {
        this.getCities();
        this.setActive(1);
        this.styles = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "saturation": "-21"
                    },
                    {
                        "gamma": "2.98"
                    },
                    {
                        "weight": "4.77"
                    },
                    {
                        "lightness": "20"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#2a4e6e"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];
        this.themeService.getTheme().subscribe((data) => {
            this.waterColor = this.themeService.getStyleAttribute('map_water_color');
            for (let i = 0; i < this.styles.length; i++) {
                if (this.styles[i].featureType === 'water') {
                    this.styles[i].stylers[0].color = this.waterColor;
                }
            }
        });
    }
    close() {
        this.router.navigateByUrl('verify');
        this.modal.destroy();
    }
    submit() {
        this.httpClient.post('user/setpersonalverificationmethod', {
            verification_method_code: 'thirdParties'
        }).subscribe((data) => {
            this.success();
            this.closeModal();
        });
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
    convertStringToNumber(value) {
        return +value;
    }
    clickedMarker(data, index, type) {
        if (type === 'atm') {
            data['isOpen'] = true;
            if (this.lastOpenIndex > -1) {
                this.atms[this.lastOpenIndex]['isOpen'] = false;
            }
            this.lastOpenIndex = index;
        }
    }
    markerClicked(event) {
    }
    setActive(tabId) {
        this.checkedCity = '';
        this.city = 0;
        if (this.activeTab !== tabId) {
            this.activeTab = tabId;
        }
        this.httpClient.get('verificationplaces/getallplaces').subscribe((result) => {
            this.atms = result;
            this.showAtms = this.atms;
        });
    }
    getCities() {
        this.httpClient.get('verificationplaces/getallcities').subscribe((result) => {
            this.cities = result;
        });
    }
    clickCity() {
        this.showCities = !this.showCities;
    }
    chooseCity(city) {
        if (this.agmMap.zoom !== 7.2) {
            const latitude = 44.4419211;
            const longitude = 20.4830112;
            this.agmMap.triggerResize().then((success) => {
                this.agmMap._mapsWrapper.setCenter({ lat: latitude, lng: longitude });
                this.agmMap._mapsWrapper.setZoom(7.2);
            });
        }
        this.city = city;
        this.showAtms = [];
        if (city === 0) {
            this.showAtms = this.atms;
            this.checkedCity = 'all';
        }
        else {
            this.showAtms = this.atms.filter(x => x["validation-city"][0] == city);
            var cityObj = this.cities.filter(x => x.id == city);
            if (cityObj.length > 0) {
                this.checkedCity = cityObj[0].name;
            }
        }
        this.showCities = false;
    }
    clickLocation(atm, index) {
        this.setActive(1);
        if (screen.height < 960) {
            this.myScrollContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.zoom = 8;
        this.longitude = parseInt(atm.longitudes) + 0.7;
        this.latitude = parseInt(atm.latitude) + 0.4;
    }
};
VerifyThirdPartiesModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    ViewChild('AgmMap')
], VerifyThirdPartiesModalComponent.prototype, "agmMap", void 0);
__decorate([
    ViewChild('scrollMe')
], VerifyThirdPartiesModalComponent.prototype, "myScrollContainer", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], VerifyThirdPartiesModalComponent.prototype, "onDocumentClick", null);
VerifyThirdPartiesModalComponent = __decorate([
    Component({
        selector: 'ecd-thirsparties-courier-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./verify-thirdparties-modal.component.html")).default
    })
], VerifyThirdPartiesModalComponent);
export { VerifyThirdPartiesModalComponent };
